import { apiRequest } from "./client";

/** Org profile + onboarding (Sprint 9, Part 89 §89.5). */

export const orgApi = {
  async getOrg() {
    return apiRequest("/api/org");
  },

  async updateOrg(patch) {
    return apiRequest("/api/org", {
      method: "PATCH",
      body: JSON.stringify(patch),
    });
  },

  async getOnboarding() {
    return apiRequest("/api/org/onboarding");
  },

  async getWhatsappStatus() {
    return apiRequest("/api/org/whatsapp/status");
  },

  async testWhatsapp(to) {
    return apiRequest("/api/org/whatsapp/test", {
      method: "POST",
      body: JSON.stringify({ to }),
    });
  },
};
